import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Loader from 'components/loading/Loader';
import translate from 'components/hoc/translate';

const StyledWrapper = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(255,255,255,.8);
`;

const StyledInner = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

const StyledMessage = styled.div`
    margin-top: 30px;
    font-size: 16px;
    font-style: italic;
    user-select: none;
`;

const BookingAmendLoader = (props) => {
    const {
        phase,
        translate,
    } = props;

    return (
        <StyledWrapper>
            <StyledInner>
                <Loader />

                <StyledMessage>{ translate(`resources.bookings.amend.loading.${ phase }`) }</StyledMessage>
            </StyledInner>
        </StyledWrapper>
    );
};

BookingAmendLoader.propTypes = {
    phase: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(BookingAmendLoader);



// WEBPACK FOOTER //
// ./src/pages/bookings/amend/BookingAmendLoader.js